import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import { AdvancedMarker, InfoWindow, Pin, useAdvancedMarkerRef } from '@vis.gl/react-google-maps';

interface IMarkerComponentProps {
  playerName: string;
  location: google.maps.LatLngLiteral;
}

const PlayerMarkerComponent: React.FC<Props> = ({ playerName, location }) => {
  const [infowindowOpen, setInfowindowOpen] = useState(false);
  const [markerRef, marker] = useAdvancedMarkerRef();

  const toggleInfowindow = () => {
    setInfowindowOpen(!infowindowOpen);
  };
  const closeInfowindow = () => {
    setInfowindowOpen(false);
  };
  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        onClick={() => toggleInfowindow()}
        position={location}
        title={playerName}
      >
        <Pin background={'#0000FF'} glyphColor={'#000'} borderColor={'#000'} />
      </AdvancedMarker>
      {infowindowOpen && (
        <InfoWindow
          anchor={marker}
          maxWidth={250}
          onCloseClick={closeInfowindow}>
          {playerName}
        </InfoWindow>
      )}
    </>
  );
};

const mapStateToProps = (_: AppState, props: IMarkerComponentProps) => ({
  playerName: props.playerName,
  location: props.location
});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PlayerMarkerComponent);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps> &
  IMarkerComponentProps
